export interface MassiveUploadDiscards {
  data: string;
  filename: string;
  type: string;
  discarded: number | null;
  total: number | null;
}

export interface MassiveUploadResult {
  processed: number | null;
  discarded: number | null;
  total: number | null;
  discards?: MassiveUploadDiscards;
}

interface MassiveUploadResponse {
  data?: unknown;
  headers?: Record<string, unknown> | null;
}

const PROCESSED_HEADER = "x-processed-records";
const DISCARDED_HEADER = "x-discarded-records";
const CONTENT_TYPE_HEADER = "content-type";
const DISCARDS_FILENAME = "FORCE-STATUS-DISCARD.csv";
const DISCARDS_TYPE = "text/csv";

const toCount = (value: unknown): number | null => {
  if (value === undefined || value === null || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const toMassiveUploadResult = (
  response?: MassiveUploadResponse | null,
): MassiveUploadResult => {
  const headers = response?.headers ?? {};
  const data = response?.data;
  const contentType = headers[CONTENT_TYPE_HEADER];
  const processed = toCount(headers[PROCESSED_HEADER]);
  const discarded = toCount(headers[DISCARDED_HEADER]);
  const total =
    processed !== null && discarded !== null ? processed + discarded : null;

  return {
    processed,
    discarded,
    total,
    ...(typeof data === "string" && data.trim() !== ""
      ? {
          discards: {
            data,
            filename: DISCARDS_FILENAME,
            type: typeof contentType === "string" ? contentType : DISCARDS_TYPE,
            discarded,
            total,
          },
        }
      : {}),
  };
};
